export const reviews = [
  {
    id: 1,
    name: 'Ahmed K.',
    nameAr: 'أحمد ك.',
    car: 'Mercedes G63',
    carAr: 'مرسيدس G63',
    rating: 5,
    comment:
      'Best mobile car wash in Kuwait! Professional service and amazing results.',
    commentAr: 'أفضل غسيل سيارات متنقل في الكويت! خدمة احترافية ونتائج مذهلة.',
    date: '2024-01-15',
    verified: true,
  },
  {
    id: 2,
    name: 'Sarah M.',
    nameAr: 'سارة م.',
    car: 'Range Rover',
    carAr: 'رنج روفر',
    rating: 5,
    comment:
      'Super convenient and the quality is exceptional. Highly recommend!',
    commentAr: 'خدمة مريحة جداً والجودة استثنائية. أنصح بهم بشدة!',
    date: '2024-01-20',
    verified: true,
  },
  {
    id: 3,
    name: 'Mohammed A.',
    nameAr: 'محمد أ.',
    car: 'Toyota Land Cruiser',
    carAr: 'تويوتا لاند كروزر',
    rating: 5,
    comment:
      'Regular customer here. Always satisfied with their premium service.',
    commentAr: 'أنا زبون دائم لديهم. دائماً راضٍ عن خدمتهم المتميزة.',
    date: '2024-01-25',
    verified: true,
  },
  {
    id: 4,
    name: 'Fatima R.',
    nameAr: 'فاطمة ر.',
    car: 'BMW X6',
    carAr: 'بي إم دبليو X6',
    rating: 5,
    comment: 'They made my car look brand new! Worth every penny.',
    commentAr: 'جعلوا سيارتي تبدو كأنها جديدة تماماً! تستحق كل فلس.',
    date: '2024-01-28',
    verified: true,
  },
];
